/**
 * @file PagePublicationsSheet.tsx
 * @description Панель «Публикации» шторкой до 1280 (phase19.16 Р3а;
 * uiux-r3 §3.1 «360 · вкладка «Страница» → шторка»): та же сводка, что в
 * группе «Настроек страницы», на всю ширину до 1280 (QA Р3а D3), и внизу
 * главное действие конструктора
 * (на 360 — на всю ширину, касание 48). На ПК пилюля в шапке раскрывает
 * группу справа, а не шторку.
 */

import { Button } from "../../ui/button";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "../../ui/sheet";
import { useBuilder } from "../builder-context";
import { useBuilderMainAction } from "../top/useBuilderMainAction";
import { PagePublications } from "./PagePublications";
import { shortActionLabel } from "../../../lib/site-builder/publish-rules";

export function PagePublicationsSheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  const b = useBuilder();
  const main = useBuilderMainAction();
  const page = b.pages.page;
  const reason = main.action.kind === "disabled" ? main.action.reason : null;
  return (
    <Sheet open={open && page !== null} onOpenChange={(next) => (!next ? onClose() : null)}>
      <SheetContent side="right" className="flex w-full max-w-none flex-col gap-4 overflow-y-auto sm:max-w-none">
        <SheetHeader>
          <SheetTitle className="line-clamp-2 break-words">Публикации · {page?.title ?? ""}</SheetTitle>
          <SheetDescription>Правки страницы — в черновике, покупатели видят версию на сайте.</SheetDescription>
        </SheetHeader>
        <div className="min-h-0 flex-1">
          <PagePublications />
        </div>
        <div className="flex flex-col gap-2 pb-[env(safe-area-inset-bottom)]">
          {reason ? <p className="type-caption text-center text-on-surface-variant">{reason}</p> : null}
          <Button variant="brand" className="h-12" disabled={main.action.kind === "disabled"} loading={main.busy}
            onClick={() => {
              // Окно публикации поверх шторки — шторку закрываем.
              if (main.action.kind === "dialog") onClose();
              main.run();
            }}
          >
            <span className="truncate">{shortActionLabel(main.action.label)}</span>
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
